import { useGetUserProfile } from "@/tanstack-hooks";
import HeaderWithInstagram from "./HeaderWithInstagram";
import HeaderWithLogout from "./HeaderWithLogout";
import { OnboardingStep, UserStatus } from "@/generated-api";
import HeaderWithMenubar from "./HeaderWithMenubar";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";

const LoggedInHeader = () => {
  const userProfileQuery = useGetUserProfile();
  const isStandalone = useStandaloneMode();

  if (userProfileQuery.isLoading) {
    return <HeaderWithInstagram />;
  }

  const user = userProfileQuery.data;

  const noContactOnboardingSteps = [
    OnboardingStep.DENIED,
    OnboardingStep.WAITLISTED,
  ];
  const showContactButton =
    user?.status === UserStatus.ONBOARDING &&
    !noContactOnboardingSteps.includes(user?.onboarding_step);
  const showRefreshButton =
    (user?.onboarding_step === OnboardingStep.APPLIED && isStandalone) ||
    (user?.onboarding_step === OnboardingStep.FACE_VERIFICATION &&
      isStandalone);
  return (
    <>
      {user?.status !== UserStatus.ACTIVE &&
      user?.status !== UserStatus.ACTIVE_HIDDEN ? (
        <HeaderWithLogout
          showRefreshButton={showRefreshButton}
          showContactButton={showContactButton}
        />
      ) : (
        <HeaderWithMenubar />
      )}
    </>
  );
};

export default LoggedInHeader;
